import React, { useState } from 'react';
import { partesAPI } from '../services/api';
import { fechaLimiteDesdeInput } from '../utils/fechaCalendario';

const ParteForm = ({ expedienteId, onParteCreated, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const [formData, setFormData] = useState({
    descripcion: '',
    fechaLimite: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Validaciones básicas
      if (!formData.descripcion || !formData.fechaLimite) {
        throw new Error('Todos los campos son obligatorios');
      }

      const parteData = {
        ...formData,
        fechaLimite: fechaLimiteDesdeInput(formData.fechaLimite)
      };

      await partesAPI.createParte(expedienteId, parteData);
      
      // Limpiar formulario
      setFormData({
        descripcion: '',
        fechaLimite: ''
      });
      
      // Notificar al componente padre
      if (onParteCreated) {
        onParteCreated();
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <div className="modal-title">
            <i className="fas fa-plus-circle modal-icon"></i>
            <h3>Agregar Nueva Parte</h3>
          </div>
          <button 
            className="modal-close" 
            onClick={onCancel}
            type="button"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="modal-body">
          {error && (
            <div className="modal-error">
              <i className="fas fa-exclamation-triangle"></i>
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="modal-form">
            <div className="form-group">
              <label htmlFor="descripcion" className="form-label">
                <i className="fas fa-edit"></i>
                Descripción *
              </label>
              <textarea
                id="descripcion"
                name="descripcion"
                className="form-control modal-input"
                value={formData.descripcion}
                onChange={handleInputChange}
                placeholder="Describe la tarea o parte del trabajo..."
                rows="4"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="fechaLimite" className="form-label">
                <i className="fas fa-calendar-alt"></i>
                Fecha Límite *
              </label>
              <input
                type="date"
                id="fechaLimite"
                name="fechaLimite"
                className="form-control modal-input"
                value={formData.fechaLimite}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="btn-modal btn-cancel"
                onClick={onCancel}
                disabled={loading}
              >
                <i className="fas fa-times"></i>
                Cancelar
              </button>
              <button
                type="submit"
                className="btn-modal btn-submit"
                disabled={loading}
              >
                <i className="fas fa-check"></i>
                {loading ? 'Creando...' : 'Crear Parte'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ParteForm;








